/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Activation adoption metrics for a skill.
 */
export type SkillAdoption = {
  /**
   * Activations observed during the rolling window.
   */
  activationsInWindow: number;
  /**
   * Distinct non-empty hostnames that activated the skill during the rolling window.
   */
  distinctHostnames: number;
  /**
   * End of the rolling adoption window.
   */
  windowEnd: Date;
  /**
   * Start of the rolling adoption window.
   */
  windowStart: Date;
};

/** @internal */
export const SkillAdoption$inboundSchema: z.ZodMiniType<
  SkillAdoption,
  unknown
> = z.pipe(
  z.object({
    activations_in_window: z.int(),
    distinct_hostnames: z.int(),
    window_end: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    window_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activations_in_window": "activationsInWindow",
      "distinct_hostnames": "distinctHostnames",
      "window_end": "windowEnd",
      "window_start": "windowStart",
    });
  }),
);

export function skillAdoptionFromJSON(
  jsonString: string,
): SafeParseResult<SkillAdoption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillAdoption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillAdoption' from JSON`,
  );
}
